import store from '../store/index'
//------------------------------------
// create race characteristic entries
//------------------------------------
export default function createRaceCharacteristicEntries(race) {
  // console.log("--------------------------------");
  // console.log("IN createRaceCharacteristicEntries");
  const this_store = store
  //-----------------------------
  // get generic characteristics
  //-----------------------------
  let chars = this_store.getters['races/getCharacteristics']
  //-----------------------------------
  // get specific race characteristics
  //-----------------------------------
  let race_chars = this_store.getters['races/getRaceCharacteristics'](race.id)
  //------
  // vars
  //------
  let val = 0
  let char_entries = []
  let char_name_array = ['str', 'con', 'dex', 'siz', 'int', 'pow', 'cha']
  //-------------------------------
  // determine char value to load
  //-------------------------------
  char_name_array.forEach((c) => {
    //
    let char_entry = []
    //
    switch (c) {
      case 'str':
        val = race.str
        break
      case 'con':
        val = race.con
        break
      case 'dex':
        val = race.dex
        break
      case 'siz':
        val = race.siz
        break
      case 'int':
        val = race.int
        break
      case 'pow':
        val = race.pow
        break
      case 'cha':
        val = race.cha
        break
      default:
        val = 0
    }
    //------------------------------------------
    // create new or update existing race chars
    //------------------------------------------
    if (race_chars != null && race_chars.length > 0) {
      //---------------------------
      // get existing race char id
      //---------------------------
      let race_char_id = race_chars.find((a) => a.name == c).id
      //-------------------------
      // set char entry (update)
      //-------------------------
      char_entry = {
        id: race_char_id,
        payload: {
          value: val,
        },
      }
    } else {
      //---------------------
      // get generic char id
      //---------------------
      let char_id = chars.find((a) => a.name == c).id
      //----------------------
      // set char entry (add)
      //----------------------
      char_entry = {
        payload: {
          race: race.id,
          characteristic: char_id,
          name: c,
          value: val,
        },
      }
    }
    //------------------
    // store char entry
    //------------------
    char_entries.push(char_entry)
  })
  return char_entries
}
